import { List } from '@ksyos/design-system';
import type { ErrorDetailsMap } from '@common/interfaces/api/practitionerDataErrorsApi';
import { PractitionerDataErrorType } from '@common/enums/practitionerDataErrorType';
import { ListItem } from '@frontend/components/elements/List/List';
import { getSelectedLanguage } from '@frontend/translate';

type ErrorDetailsCellProps = {
    details: ErrorDetailsMap[PractitionerDataErrorType];
    type: PractitionerDataErrorType;
};

export default function ErrorDetailsCell({ type, details }: Readonly<ErrorDetailsCellProps>) {
    const translate = getSelectedLanguage();

    switch (type) {
        case PractitionerDataErrorType.vektisNameMismatch:
            return (
                <List styleType="bullet">
                    <ListItem>
                        <span className="font-weight-bold">
                            {translate.practitioner.practitionerDataErrorDetails.clientSafeLastName}
                        </span>
                        : {details?.clientSafeLastName}
                    </ListItem>
                    <ListItem>
                        <span className="font-weight-bold">
                            {translate.practitioner.practitionerDataErrorDetails.vektisLastName}
                        </span>
                        :{details?.vektisLastName}
                    </ListItem>
                </List>
            );
        default:
            return <></>;
    }
}
